import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExportType } from "@src/api-client/web-api-client";
import { v4 as uuidv4 } from "uuid";

export interface IExportState {
    isExporting: boolean;
    exportType: ExportType | undefined;
    activeExports: Record<string, ExportType | undefined>;
}

const initialState: IExportState = {
    isExporting: false,
    exportType: undefined,
    activeExports: {},
};

export interface IExportOperation {
    operationId: string;
    exportType?: ExportType;
}

export function createExportOperationId(): string {
    return uuidv4();
}

export const exportingSlice = createSlice({
    name: "exporting",
    initialState: initialState,
    reducers: {
        beginExport: (state, action: PayloadAction<IExportOperation>) => {
            state.activeExports[action.payload.operationId] =
                action.payload.exportType;
            state.isExporting = true;
            state.exportType = action.payload.exportType;
        },
        finishExport: (state, action: PayloadAction<string>) => {
            delete state.activeExports[action.payload];

            const activeOperationIds = Object.keys(state.activeExports);
            state.isExporting = activeOperationIds.length > 0;
            state.exportType = state.isExporting
                ? state.activeExports[
                      activeOperationIds[activeOperationIds.length - 1]
                  ]
                : undefined;
        },
    },
});

export const { beginExport, finishExport } = exportingSlice.actions;

export default exportingSlice.reducer;
